const serviceAreaData = [
  "Kankarbagh",
  "Patliputra Colony",
  "Boring Road",
  "Rajendra Nagar",
  "Ashok Rajpath",
  "Bailey Road",
  "Danapur",
  "Phulwari Sharif",
  "Anisabad",
  "Gardanibagh",
  "Patna City",
  "Rajiv Nagar",
  "AG Colony",
  "Kadam Kuan",
  "Sri Krishna Puri",
  "Rukanpura",
  "Khagaul",
  "Digha",
  "Mithapur",
  "Kurji",
  "Hanuman Nagar"
];
export default serviceAreaData;